import React, { useState } from "react";
import { TextField, Button, Box, Typography, Grid } from "@mui/material";
import { ReactComponent as PlushIcon } from "../../assets/dashboardIcons/plusicon.svg";
import { ReactComponent as Wifi } from "../../assets/dashboardIcons/wifiIcon.svg";
import { LocalizationProvider, DateTimePicker, DatePicker } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { useForm, Controller } from "react-hook-form";
import MenuWithPDF from "../filter/MenuWithPDF";
import dayjs from 'dayjs';
import 'dayjs/locale/it';
import { useSelector } from "react-redux";
import produzioniFormAPI from "../../services/produzioniFormApi";
dayjs.locale('it');

const TableInputPressatura = ({ option, rows, setRows, activeStep }) => {
    const singleProduzioneID = useSelector((state) => state.produzioni.singleProduzioneId);
    const { control } = useForm();
    // const [rows, setRows] = useState([
    //     { id: 1, date: null, vinaccia: "", restaMosto: "", phVino: "" },
    //     { id: 2, date: null, vinaccia: "", restaMosto: "", phVino: "" },
    //     { id: 3, date: null, vinaccia: "", restaMosto: "", phVino: "" },
    // ]);

    const handleInputChange = (index, field, value) => {
        const updatedRows = [...rows];
        updatedRows[index][field] = value;
        setRows(updatedRows);
    };

    const addRow = () => {
        setRows([
            ...rows,
            { company_id: Number(localStorage.getItem('company_id')) || "", step: activeStep, prod_id: singleProduzioneID, date_pressatura: null, qty_vinaccia_ottenuta: "", percentage_resta_in_mosto: "", Ph_del_vino_svinato: "" }
        ]);
    };

    const handleDelete = async (index) => {
        const row = rows[index];
    
        if (row.id) {
          try {
            await produzioniFormAPI.deleteStepFormRow({
                id: row.id, 
                formName: "svinatura"
            });
          } catch (err) {
            console.error("Error deleting row from server:", err);
            return;
          }
        }

        setRows((prev) => prev.filter((_, i) => i !== index));
      };

    return (
        <Box className="tableInput" sx={{ maxWidth: "100%", padding: 2 }}>
            <h3 className="sectiontitleSmall">Pressatura e svinatura</h3>

            <Grid container spacing={1} sx={{ marginBottom: 1, fontWeight: "bold", color: "gray" }}>
                <Grid  size={.5}><Typography>ID</Typography></Grid>
                <Grid  size={2.5}><Typography>Data pressatura</Typography></Grid>
                <Grid  size={2.5}><Typography>Q.ta vinaccia ottenuta (Kg)</Typography></Grid>
                <Grid  size={3.9}><Typography>Resta in mosto (% calcolo automatico)</Typography></Grid>
                <Grid  size={2.5}>
                    <Box className="inputBoxIcon heading">
                        <p>PH del vino svinato</p>
                        <Wifi className="wifiIcon" />
                    </Box>
                </Grid>
            </Grid>

            {rows?.map((row, index) => (
                <>

                    <Grid container spacing={1} key={index} sx={{ marginBottom: 1 }}>
                        <Grid  size={.5}>
                            <TextField
                                className="customTextBox"
                                label="ID"
                                size="small"
                                value={row?.id || index}
                                disabled
                            />
                        </Grid>
                        <Grid  size={2.5}>
                            <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="it">
                                <Controller
                                    name={`date-${index}`}
                                    control={control}
                                    render={({ field }) => (
                                        <DatePicker
                                            label="Data pressatura"
                                            className='datePickerField'
                                            value={row.date_pressatura ? dayjs(row.date_pressatura) : null}
                                            onChange={(newValue) => {
                                                const formattedDate = dayjs(newValue).format("YYYY-MM-DD");
                                                handleInputChange(index, "date_pressatura", formattedDate);
                                                field.onChange(formattedDate);
                                            }}
                                            renderInput={(params) => (
                                                <TextField {...params} fullWidth margin="normal" size="small" />
                                            )}
                                        />
                                    )}
                                />
                            </LocalizationProvider>
                        </Grid>
                        <Grid  size={2.5}>
                            <TextField
                                className="customTextBox"
                                label="Q.ta vinaccia ottenuta (Kg)"
                                size="small"
                                onChange={(e) => handleInputChange(index, "qty_vinaccia_ottenuta", e.target.value)}
                                value={row.qty_vinaccia_ottenuta}
                            />
                        </Grid>
                        <Grid  size={3.9}>
                            <TextField
                                className="customTextBox"
                                label="Resta in mosto (% calcolo automatico)"
                                size="small"
                                onChange={(e) => handleInputChange(index, "percentage_resta_in_mosto", e.target.value)}
                                value={row.percentage_resta_in_mosto}
                            />
                        </Grid>
                        <Grid  size={2.5}>
                            <Box className="inputBoxIcon">
                                <TextField
                                    className="customTextBox"
                                    label="PH del vino svinato"
                                    onChange={(e) => handleInputChange(index, "Ph_del_vino_svinato", e.target.value)}
                                    size="small"
                                    value={row.Ph_del_vino_svinato}
                                />
                                <Wifi className="wifiIcon" />
                            </Box>
                        </Grid>
                        <Grid  size={.1}>
                            <MenuWithPDF
                                options={option}
                                handleDelete={(event) => {
                                    event?.stopPropagation();
                                    handleDelete(index);
                                }}
                            />
                        </Grid>
                    </Grid>

                </>
            ))}

            <Button
                variant="body2"
                onClick={addRow}
                sx={{
                    cursor: 'pointer', color: "#225CA6", mt: 1, gap: "6px",
                    fontFamily: 'Public Sans, sans-serif !important',
                    '&:hover': {
                        color: '#57C700',
                        background: "transparent"
                    }
                }}
            >
                <PlushIcon /> aggiungi pressatura e svinatura
            </Button>
        </Box>
    );
};

export default TableInputPressatura;